import Vue from 'vue';
import Router from 'vue-router';
import homepower from '@/view/home_power';
import centerwifi from '@/view/center_wifi';
import centerpower from '@/view/center_power';
import centermotorcycle from '@/view/center_motorcycle';
import centercloud from '@/view/center_cloud';
import centerbms from '@/view/center_bms';
import aboutus from '@/view/about_us';
import onlineEnquiry from '@/view/online_enquiry';
import cooperateChain from '@/view/cooperate_chain';
import outdoorpower from '@/view/outdoorpower';

Vue.use(Router)

export default new Router(
  {
    // 页面跳转显示在顶部
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
    mode: 'hash',// 注意:history模式不能生成静态文件部署.hash模式可以生成静态文件部署,缺点就是网址路径包含#符号
    base: '/',
    routes: [{
            path: '/',
            redirect: 'homepower'
        },
        {
            path: '/homepower',
            name: 'homepower',
            component: homepower,
            meta: {
                title: "langs.homepower",
                content: {
                    keywords: "langs.keywords.home",
                    description: "langs.description.home"
                }
            }
        },
        {
            path: '/centerpower',
            name: 'centerpower',
            component: centerpower,
            meta: {
                title: "langs.centerpower",
                content: {
                    keywords: "langs.keywords.storage",
                    description: "langs.description.storage"
                }
            }
        },
        {
            path: '/outdoorpower',
            name: 'outdoorpower',
            component: outdoorpower,
            meta: {
                title: "langs.outdoorpower",
                content: {
                    keywords: "langs.keywords.storage",
                    description: "langs.description.storage"
                }
            }
        },
        {
            path: '/centerbms',
            name: 'centerbms',
            component: centerbms,
            meta: {
                title: "langs.centerbms",
                content: {
                    keywords: "langs.keywords.bms",
                    description: "langs.description.bms"
                }
            }
        }, {
            path: '/centermotorcycle',
            name: 'centermotorcycle',
            component: centermotorcycle,
            meta: {
                title: "langs.centermotorcycle",
                content: {
                    keywords: "langs.keywords.tricycle",
                    description: "langs.description.tricycle"
                }
            }
        }, {
            path: '/centercloud',
            name: 'centercloud',
            component: centercloud,
            meta: {
                title: "langs.centercloud",
                content: {
                    keywords: "langs.keywords.cloud",
                    description: "langs.description.cloud"
                }
            }
        }, {
            path: '/centerwifi',
            name: 'centerwifi',
            component: centerwifi,
            meta: {
                title: "langs.centerwifi",
                content: {
                    keywords: "langs.keywords.wifi",
                    description: "langs.description.wifi"
                }
            }
        }, {
            path: '/aboutus',
            name: 'aboutus',
            component: aboutus,
            meta: {
                title: "langs.aboutus",
                content: {
                    keywords: "langs.keywords.aboutus",
                    description: "langs.description.aboutus"
                }
            }
        }, {
            path: '/onlineEnquiry',
            name: "onlineEnquiry",
            component: onlineEnquiry,
            meta: {
                title: "langs.onlineEnquiry",
                content: {
                    keywords: "langs.keywords.aboutus",
                    description: "langs.description.aboutus"
                }
            }
        }, {
            path: '/cooperateChain',
            name: "cooperateChain",
            component: cooperateChain,
            meta: {
                title: "langs.cooperateChain",
                content: {
                    keywords: "langs.keywords.aboutus",
                    description: "langs.description.aboutus"
                }
            }
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js